<mat-expansion-panel (opened)="onOpened.emit(postedAircraftTripSkeleton.postedAircraftTripId)">
  <mat-expansion-panel-header>
    Trip ID: {{ postedAircraftTripSkeleton.customTripId }}
    <span *ngIf="postedAircraftTripSkeleton.isDeleted">&nbsp;(Deleted)</span>
  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>
    <div *ngIf="postedAircraftTripAuditLoading">Loading...</div>
    <div *ngIf="postedAircraftTripAuditLoaded">
      <div
        *ngIf="
          postedAircraftTripAudit && postedAircraftTripAudit.length > 0;
          else noPostedAircraftTripAudits
        "
      >
        <sd-portal-audit-detail-list
          [audits]="postedAircraftTripAudit"
          (nextPage)="onNextPage.emit(postedAircraftTripSkeleton.postedAircraftTripId)"
        ></sd-portal-audit-detail-list>
      </div>
      <ng-template #noPostedAircraftTripAudits> No audit records for this trip </ng-template>
    </div>

    <div
      class="leg-container"
      *ngIf="postedAircraftTripSkeleton.legs && postedAircraftTripSkeleton.legs.length > 0"
    >
      <mat-accordion>
        <mat-expansion-panel
          *ngFor="let leg of postedAircraftTripSkeleton.legs"
          (opened)="legOpened(postedAircraftTripSkeleton.postedAircraftTripId, leg.postedFlightId)"
        >
          <mat-expansion-panel-header> Log #{{ leg.logNumber }} </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div *ngIf="postedAircraftTripLegAuditLoading">Loading...</div>
            <div *ngIf="postedAircraftTripLegAuditLoaded">
              <div
                *ngIf="
                  postedAircraftTripLegAudit && postedAircraftTripLegAudit.length > 0;
                  else noPostedAircraftTripLegAudits
                "
              >
                <sd-portal-audit-detail-list
                  [audits]="postedAircraftTripLegAudit"
                  (nextPage)="
                    legNextPage(postedAircraftTripSkeleton.postedAircraftTripId, leg.postedFlightId)
                  "
                ></sd-portal-audit-detail-list>
              </div>
              <ng-template #noPostedAircraftTripLegAudits>
                No audit records for this leg
              </ng-template>
            </div>
          </ng-template>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </ng-template>
</mat-expansion-panel>
